module.exports = __webpack_public_path__ + "img/bsjg_01.c30e23cf.png";